// 老师端- 活动管理 - 班级管理及班级学生
import services from '../assets/js/services'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    // 获取班级列表
    getSchoolActivityClasses (context, payload) {
      return services.getSchoolActivityClasses(payload).then(res => {
        return res;
      })
    },
    // 班级添加
    addSchoolActivityClasses (context, payload) {
      return services.addSchoolActivityClasses(payload).then(res => {
        return res;
      })
    },
    //  班级编辑、删除
    editSchoolActivityClasses (context, payload) {
      return services.editSchoolActivityClasses(payload).then(res => {
        return res;
      })
    },
    //  班级详情
    getSchoolActivityClassesInfo (context, payload) {
      return services.getSchoolActivityClassesInfo(payload).then(res => {
        return res;
      })
    },
    // 获取班级学生列表
    getSchoolClassesMember (context, payload) {
        return services.getSchoolClassesMember(payload).then(res => {
          return res;
        })
      },
    // 班级学生库列表
    filterSchoolClassesUser (context, payload) {
        return services.getSchoolStudent(payload).then(res => {
            return res;
        })
    },
    //  班级学生删除
    delSchoolClassesMember (context, payload) {
        return services.delSchoolClassesMember(payload).then(res => {
            return res;
        })
    },
    //  从学生库选择
    chooseSchoolClassesMember(context, payload) {
        return services.chooseSchoolClassesMember(payload).then(res => {
            return res;
        })
    },
  
    
  },
  mutations: {
  }
}